"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutWithBreadCrumb = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var FillViewHeight_1 = require("../FillViewHeight");
var Breadcrumb_1 = __importDefault(require("../../components/Breadcrumb"));
var DEFAULT_COLORS = {
    bg: "#ebeff3",
};
var LayoutWithBreadCrumb = function (_a) {
    var breadCrumb = _a.breadCrumb, children = _a.children, extra = _a.extra, _b = _a.colors, colors = _b === void 0 ? DEFAULT_COLORS : _b;
    return (react_1.default.createElement(antd_1.Row, null,
        breadCrumb && (react_1.default.createElement(antd_1.Col, { xs: 24, style: { padding: "1rem" } },
            react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                react_1.default.createElement(antd_1.Col, null,
                    react_1.default.createElement(Breadcrumb_1.default, __assign({}, breadCrumb))),
                react_1.default.createElement(antd_1.Col, null, extra === null || extra === void 0 ? void 0 : extra.right)))),
        react_1.default.createElement(antd_1.Col, { xs: 24, style: { background: colors.bg, padding: "1rem" } }, children)));
};
exports.LayoutWithBreadCrumb = LayoutWithBreadCrumb;
var WithFillViewHeight = function (_a) {
    var children = _a.children, fullViewHeight = _a.fullViewHeight, rest = __rest(_a, ["children", "fullViewHeight"]);
    return (react_1.default.createElement(LayoutWithBreadCrumb, __assign({}, rest),
        react_1.default.createElement(FillViewHeight_1.FillViewHeight, __assign({}, fullViewHeight, { offset: "1rem" }), children)));
};
LayoutWithBreadCrumb.WithFillViewHeight = WithFillViewHeight;
